import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_futuroja.png",
      alt: "Estratégias Futuro Já",
    },
    title: "Seu Futuro Começa Já",

    // String ou array de strings
    text: [
      "Descubra o futuro agora com o robô de day trade Universe Flow WIN da Futuro Já! Revolucione sua experiência de negociação com a Futuro Já, empresa pioneira na automatização de day trading para investidores pessoas físicas na B3. Diga adeus às complexidades da negociação manual e abrace a nova era do trade.",
    ],
    testimonial: {
      text: "Nós da Futuro Já operamos de forma automatizada desde 2008 na bolsa de valores B3 e continuamos aqui.",
      author: {
        name: "Marcel Mallio",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégia Universe Flow WIN",
    heading: "Setup de Leilão integrado com aceleração de mercado",
    subtitle:
      "Estratégia entra junto com os grandes players de mercado logo no leilão de abertura, assim como também em momentos de aceleração de mercado.",
  },

  cta: {
    title: "Não perca mais tempo e junte-se a nós agora!",
    subtitle: "Ative agora mesmo nosso robô Universe Flow Win",
    // buttonText: "Quero investir",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Futuro Já",
    col1: [
      "A empresa Futuro Já é reconhecida por sua inovação e pioneirismo ao automatizar o day trade na bolsa de valores B3, utilizando as mais recentes tecnologias disponíveis. Sua abordagem oferece oportunidades reais para os seus usuários, que historicamente desfrutam de retornos de mais de 100% sobre capital investido com uso da alavancagem. Além disso, a empresa demonstra um compromisso com a transparência e a eficiência no mercado financeiro, criando robôs de performance reconhecidas pelos seus usuários.",
    ],
    // col2: [
    //   "Formado por um time de profissionais com mais de 5 anos de experiência no mercado financeiro, como Victor Hugo Montoro, trader experiente em mercado futuro, e Leonardo Martins, especialista em automatização de processos.",
    //   "Desde então estamos buscando por mais conhecimento e novos desenvolvimentos, para aprimorar e facilitar o processo de quem quer se tornar um investidor de sucesso.",
    // ],
  },

  stats: {
    title: "Conheça a Futuro Já",
    subtitle:
      "Operando de forma automatizada na b3 desde 2008 e continuamos aqui",
    data: [
      {
        value: "+10",
        description: "Anos em atividade",
      },
      {
        value: "+de 100%",
        description: "De rendimento em 2023",
      },
      {
        value: "+11",
        description: "Meses consecutivos de gain",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs Futuro Já?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossa estratégia e confira a performance em sua conta",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos ajustes e parametrizações da estratégia automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar cálculos após a abertura, tomando decisões mais rápido que qualquer ser humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe Tempo",
        description:
          "Você não precisa ficar na frente do computador para realizar suas operações. Após sua escolha, a automação opera por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emocional",
        description:
          "Com a estratégia automatizada você vai acabar com todos seus problemas de tomar decisões impulsivas e irracionais",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A possibilidade de automatizar o day trade com robôs investidores proporciona uma maior tranquilidade e eficiência com a Futuro Já na gestão dos meus robôs.",
      author: "Thais Oliveira",
      job: "Dentista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "A Futuro Já revolucionou minha forma de investir. Com as tecnologias inovadoras e a expertise deles no day trade, consegui aumentar meus rendimentos de forma consistente. Recomendo para todos que buscam oportunidades reais na bolsa de valores.",
      author: "Anibal Jefferson",
      job: "Autônomo",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
